import api from '../utils/api';

// Fetch all attendance records
export const getAllAttendance = async (headers) => {
  try {
    const response = await api.get('/api/attendance', headers);
    console.log("all attendances", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching attendance records:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific attendance record by ID
export const getAttendanceById = async (id, headers) => {
  try {
    const response = await api.get(`/api/attendance/${id}`, headers);
    console.log("get attendace by ", response)
    return response.data;
  } catch (error) {
    console.error(`Error fetching attendance record with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new attendance record
export const createAttendance = async (attendanceData, headers) => {
  try {
    const response = await api.post('/api/attendance', attendanceData, headers);
    console.log("created", response)
    return response.data;
  } catch (error) {
    console.error('Error creating attendance record:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing attendance record
export const updateAttendance = async (id, attendanceData, headers) => {
  try {
    const response = await api.put(`/api/attendance/${id}`, attendanceData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error updating attendance record with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete an attendance record
export const deleteAttendance = async (id, headers) => {
  try {
    const response = await api.delete(`/api/attendance/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting attendance record with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch specific student's attendance 
export const getSpecificStudentAttendanceById = async (studentId, headers) => {
  try {
    const response = await api.get(`/api/attendance/student/${studentId}`, headers);
    console.log("get specific student's attendance", response);
    return response.data;
  } catch (error) {
    console.error(`Error fetching attendance records for student ID ${studentId}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch specific teacher's attendance
export const getSpecificTeacherAttendanceById = async (teacherId, headers) => {
  try {
    const response = await api.get(`/api/attendance/teacher/${teacherId}`, headers);
    console.log("get specific teacher's attendance", response);
    return response.data;
  } catch (error) {
    console.error(`Error fetching attendance records for teacher ID ${teacherId}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch specific staff's attendance
export const getSpecificStaffAttendanceById = async (staffId, headers) => {
  try {
    const response = await api.get(`/api/attendance/staff/${staffId}`, headers);
    console.log("get specific staff's attendance", response);
    return response.data;
  } catch (error) {
    console.error(`Error fetching attendance records for staff ID ${staffId}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};